import { render, staticRenderFns } from "./HomePageView.vue?vue&type=template&id=12a9630b"
import script from "./HomePageView.vue?vue&type=script&lang=ts"
export * from "./HomePageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports